import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { connect } from 'react-redux';
import RoundedButtonLinkAction from '../../../components/button/rounded-button-link-action/RoundedButtonLinkAction';
import { ContentTitle, Title } from '../../../components/typography/Heading';
import { fetchProjectCardWithPreviousMoneygoal } from '../../../project/project-actions';
import { getProjectFromId } from '../../../project/projects-reducer';
import { formatMoneyKr } from '../../../utils';
import styles from '../p3aksjonen.module.less';
import P3VotingProgressBar from '../voting-progress-bar/P3VotingProgressBar';

const BACKUP_MONEY_GOAL_INCREASE = 50_000;

const getPercentageFromLastGoal = ({ collected_amount, moneygoal }) => {
    return (collected_amount / moneygoal) * 100;
};

const VoteForInStudioEvent = ({ id, collected_amount, moneygoal, children, progressBarClassName, backupMoneyGoal }) => {
    const goalToUse = backupMoneyGoal ?? moneygoal;
    const percentageFromLastGoal = getPercentageFromLastGoal({ collected_amount, moneygoal: goalToUse });
    const goalIsSet = !!goalToUse;
    return (
        <div className={styles.voteContainer}>
            <Title>{children}</Title>
            {goalIsSet ? (
                <>
                    <P3VotingProgressBar percent={percentageFromLastGoal} className={progressBarClassName} />
                    <Title className={styles.remainingBeforeStudioEvent}>{formatMoneyKr(collected_amount)}</Title>
                </>
            ) : (
                <p>Ingen mål satt ennå</p>
            )}
            <RoundedButtonLinkAction className={styles.supportButton} to={`/project/${id}/payment`}>
                Støtt
            </RoundedButtonLinkAction>
        </div>
    );
};

const ProjectDuel = ({ projectList = [] }) => {
    const projectXId = projectList[0];
    const projectYId = projectList[1];
    const projectX = useSelector((state) => getProjectFromId(state, projectList[0]));
    const projectY = useSelector((state) => getProjectFromId(state, projectList[1]));
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchProjectCardWithPreviousMoneygoal(projectXId));
        dispatch(fetchProjectCardWithPreviousMoneygoal(projectYId));
    }, []);

    const missingMoneyGoal = !projectX?.moneygoal || !projectY?.moneygoal;
    const highestCollectedAmount =
        projectX?.collected_amount > projectX?.collected_amount
            ? projectX?.collected_amount
            : projectY?.collected_amount;
    const backupMoneyGoal = missingMoneyGoal ? parseInt(highestCollectedAmount, 10) + BACKUP_MONEY_GOAL_INCREASE : null;

    return (
        <section className={styles.goodBadSection}>
            <ContentTitle className={styles.title}>Duell</ContentTitle>
            <div className={styles.goodBadCardContainer}>
                <VoteForInStudioEvent
                    id={projectX?.id}
                    moneygoal={projectX?.moneygoal}
                    previousMoneygoal={projectX?.previousMoneygoal}
                    backupMoneyGoal={backupMoneyGoal}
                    collected_amount={projectX?.collected_amount}
                    classname={styles.title}
                    progressBarClassName={styles.progressChallenge}
                >
                    <div>{projectX?.title}</div>
                </VoteForInStudioEvent>
                <VoteForInStudioEvent
                    id={projectY?.id}
                    moneygoal={projectY?.moneygoal}
                    previousMoneygoal={projectY?.previousMoneygoal}
                    backupMoneyGoal={backupMoneyGoal}
                    collected_amount={projectY?.collected_amount}
                    progressBarClassName={styles.progressChallenge}
                >
                    <div>{projectY?.title}</div>
                </VoteForInStudioEvent>
            </div>
        </section>
    );
};

const mapStateToProps = (state, { projectList = [] }) => ({
    positiveProject: getProjectFromId(state, projectList[0]),
    negativeProject: getProjectFromId(state, projectList[1]),
});

export default connect(mapStateToProps)(ProjectDuel);
